const style = {
  overflowY: "scroll",
  margin: 0,
  padding: 0,
  height: 352,
  listStyleType: "none"
};

export function ItemContainer(props) {
  return (<>
    <ul style={ style }>{ props.children }</ul>
  </>);
}
